import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import "../../../../assets/css/style.css";
import Form from "./Form.js";
import ContentWithImages from "./ContentWithImages.js";
import DoctorBite from "../../DoctorBite.js";
import PatientReviews from "../../PatientReview.js";
import GetInTouch from "../../GetInTouch.js";
import FollowYt from "../../FollowYt.js";
import Counter from "../../../NumCounter.js";
import Breadcrumb from "../../Breadcrum.js";

export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
      <Helmet>
      <title>Facial Aesthetics in Delhi, India | Treatments, Cost, Doctor, Clinic</title>
      <meta name="description" content="Get advanced facial aesthetics treatments in Delhi, India. Learn about procedures, recovery, and cost at MedFirst ENT Centre." />
      <meta name="keywords" content="facial aesthetics Delhi, cosmetic ENT, facial treatments, skin rejuvenation, botox clinic Delhi, fillers, aesthetic treatments" />
      <link rel="canonical" href="https://entdelhi.com/facial-aesthetics/" />
      <meta property="og:title" content="Facial Aesthetics in Delhi, India | Treatments, Cost, Doctor, Clinic" />
      <meta property="og:description" content="Get advanced facial aesthetics treatments in Delhi, India. Learn about procedures, recovery, and cost at MedFirst ENT Centre." />
      <meta name="robots" content="index, follow" />
      {/* You can add more meta tags as needed */}
    </Helmet>
     <main>
        <Breadcrumb/>
        <Form />  
        <Counter />
        <ContentWithImages />
        <FollowYt />
        <DoctorBite />
        <PatientReviews />
        <GetInTouch />
      </main>
    </div>
  );
}
